module.exports = __webpack_public_path__ + "img/rongyu-03.bc4bfa36.png";